import { Box, FormControl, FormControlLabel, Grid, MenuItem, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import React from 'react';

const THEME_SAFE_SELECT_MENU_PROPS = {
  PaperProps: {
    className: 'eops-select-menu-paper',
    sx: {
      backgroundColor: 'var(--eops-bg-form)',
      backgroundImage: 'none',
      color: 'var(--eops-text)',
      border: '1px solid var(--eops-border)',
      '& .MuiMenuItem-root': {
        color: 'var(--eops-text-secondary)',
      },
      '& .MuiMenuItem-root:hover, & .MuiMenuItem-root.Mui-focusVisible': {
        backgroundColor: 'var(--eops-bg-input)',
      },
      '& .MuiMenuItem-root.Mui-selected': {
        backgroundColor: 'rgba(37, 99, 235, 0.22)',
        color: 'var(--eops-text)',
      },
      '& .MuiMenuItem-root.Mui-selected:hover': {
        backgroundColor: 'rgba(37, 99, 235, 0.32)',
      },
    },
  },
};

const DARK_SAFE_SELECT_MENU_PROPS = THEME_SAFE_SELECT_MENU_PROPS;

const CustomerInformationCard = ({
    searchBy,
    SearchBy,
    allowedSearchBy = ['referenceNo', 'consumerId'],
    errors,
    values,
    touched,
    handleChange,
    handleBlur,
    defaultCircle,
    circleList,
    setDefaultCircle,
    defaultDivision,
    divisionList,
    setDefaultDivision,
    subDivision,
    subDivisionList,
    setSubDivision,
    showSubmitErrors = false,
    hideCategory = false,
    hideTariff = false,
    hideMeterType = false,
    hidePhase = false,
    showTelco = false,
    showStatusAfterAddress = false,
    showCompany = false,
    companyDisplayName = '',
    layoutVariant = 'default',
}) => {

    // Check if only one search option is allowed
    const isSingleSearchOption = allowedSearchBy.length === 1;
    // MCO-style forms: telco + phone, no category/tariff — use wider responsive columns
    const isWideLayout = showTelco && hideCategory && hideTariff;
    const isRcoLayout = layoutVariant === 'rco';
    const isAlbLayout = layoutVariant === 'alb';
    const isPpLayout = layoutVariant === 'pp';
    const isInstLayout = layoutVariant === 'inst';
    const isSplitRow2Layout = isRcoLayout || isAlbLayout || isPpLayout || isInstLayout;

    const handleReferenceNumberChange = (event) => {
        const digitsOnly = event.target.value.replace(/\D/g, '').slice(0, 14);
        handleChange({
            target: {
                name: 'iv_reference_number',
                value: digitsOnly,
            },
        });
    };

    const handleConsumerIdChange = (event) => {
        const digitsOnly = event.target.value.replace(/\D/g, '').slice(0, 10);
        handleChange({
            target: {
                name: 'iv_consumer_id',
                value: digitsOnly,
            },
        });
    };

    const col = isWideLayout
        ? {
            search: { xs: 12, sm: 6, md: 4, lg: 3 },
            ref: { xs: 12, sm: 6, md: 4, lg: 2 },
            name: { xs: 12, sm: 6, md: 4, lg: 2.5 },
            father: { xs: 12, sm: 6, md: 4, lg: 2.5 },
            cnic: { xs: 12, sm: 6, md: 4, lg: 2 },
            telco: { xs: 12, sm: 6, md: 3, lg: 1.5 },
            phone: { xs: 12, sm: 6, md: 3, lg: 1.5 },
            narrow: { xs: 12, sm: 6, md: 4, lg: 2.25 },
            phaseMeter: { xs: 12, sm: 4, md: 2, lg: 1.5 },
            locationSm: { xs: 12, sm: 4, md: 2, lg: 1.75 },
            address: { xs: 12, sm: 12, md: 4, lg: 3.75 },
            location: { xs: 12, sm: 6, md: 4, lg: 2.5 },
        }
        : isRcoLayout
        ? {
            search: { xs: 12 },
            ref: { xs: 1.25 },
            name: { xs: 2.25 },
            father: { xs: 2.25 },
            cnic: { xs: 2 },
            telco: { xs: 2 },
            phone: { xs: 2 },
            narrow: { xs: 1 },
            phase: { xs: 3 },
            location: { xs: 1.75 },
            division: { xs: 1.75 },
            subDivision: { xs: 1.75 },
            address: { xs: 4 },
            status: { xs: 1.5 },
        }
        : isPpLayout
        ? {
            search: { xs: 3 },
            ref: { xs: 3 },
            name: { xs: 3 },
            father: { xs: 3 },
            cnic: { xs: 3 },
            telco: { xs: 1 },
            phone: { xs: 2 },
            narrow: { xs: 2 },
            phaseMeter: { xs: 3 },
            location: { xs: 3 },
            address: { xs: 3 },
            status: { xs: 2 },
        }
        : isInstLayout
        ? {
            search: { xs: 3 },
            ref: { xs: 2 },
            name: { xs: 3 },
            father: { xs: 2 },
            cnic: { xs: 2 },
            telco: { xs: 1 },
            phone: { xs: 2 },
            narrow: { xs: 2 },
            phaseMeter: { xs: 3 },
            tariff: { xs: 3 },
            location: { xs: 2 },
            address: { xs: 6 },
            status: { xs: 2 },
        }
        : isAlbLayout
        ? showTelco
          ? {
              // MRC: clean rows with Telco/Phone + hierarchy
              // Row1: Search By | Customer ID | Name | Father's Name | CNIC
              // Row2: Telco | Phone | Category | Tariff | Company?
              // Row3: Circle | Division | Sub Division | Address
              // Use lg (not only md) so 16" laptop content width wraps cleanly
              search: { xs: 12, sm: 6, md: 4, lg: 2.4 },
              ref: { xs: 12, sm: 6, md: 4, lg: 2.4 },
              name: { xs: 12, sm: 6, md: 4, lg: 2.4 },
              father: { xs: 12, sm: 6, md: 6, lg: 2.4 },
              cnic: { xs: 12, sm: 6, md: 6, lg: 2.4 },
              telco: { xs: 12, sm: 6, md: 4, lg: 2.4 },
              phone: { xs: 12, sm: 6, md: 4, lg: 2.4 },
              narrow: { xs: 12, sm: 6, md: 4, lg: 2.4 },
              tariff: { xs: 12, sm: 6, md: 4, lg: 2.4 },
              location: {
                xs: 12,
                sm: 6,
                md: 4,
                lg: 2,
              },
              address: {
                xs: 12,
                sm: 12,
                md: 12,
                lg: 6,
              },
              status: { xs: 12, sm: 6, md: 4, lg: 2 },
            }
          : showCompany
          ? {
              // Admin + Company (no telco): wrap into readable rows.
              search: { xs: 12, sm: 6, md: 3 },
              ref: { xs: 12, sm: 6, md: 3 },
              name: { xs: 12, sm: 6, md: 3 },
              father: { xs: 12, sm: 6, md: 3 },
              cnic: { xs: 12, sm: 6, md: 3 },
              telco: { xs: 12, sm: 6, md: 2 },
              phone: { xs: 12, sm: 6, md: 4, lg: 2.4 },
              narrow: { xs: 12, sm: 6, md: 4, lg: 2.4 },
              location: { xs: 12, sm: 6, md: 3, lg: 3 },
              address: { xs: 12 },
              status: { xs: 12, sm: 6, md: 2 },
            }
          : {
              search: { xs: 2.5 },
              ref: { xs: isSingleSearchOption ? 3 : 2 },
              name: { xs: isSingleSearchOption ? 3 : 2.5 },
              father: { xs: 3 },
              cnic: { xs: isSingleSearchOption ? 3 : 2 },
              telco: { xs: 1 },
              phone: { xs: 1 },
              narrow: { xs: 1 },
              location: { xs: 1 },
              address: { xs: 4 },
              status: { xs: 2 },
            }
        : {
            search: { xs: 2.5 },
            ref: { xs: 1.5 },
            name: { xs: 3 },
            father: { xs: 3 },
            cnic: { xs: 2 },
            telco: { xs: 1 },
            phone: { xs: 1 },
            narrow: { xs: 1 },
            location: { xs: 4 / 3 },
            address: { xs: 4 },
            status: { xs: 2 },
        };

    const applicantPpRow2Fields = (
        <>
            {!hideCategory && (
            <Grid item {...col.narrow}>
                <Typography className='fieldLabel'>Category</Typography>
                <TextField
                    fullWidth
                    required
                    type='text'
                    name="iv_connection_type"
                    disabled
                    autoComplete='off'
                    value={values.iv_connection_type}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField1 customer-input-unified'
                />
                <Box className='from-Error'>
                    {errors.iv_connection_type && touched.iv_connection_type ? (errors.iv_connection_type) : null}
                </Box>
            </Grid>
            )}
            <Grid item {...col.phone}>
                <Typography className='fieldLabel'>
                    Phone No. <span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                    fullWidth
                    required
                    type='text'
                    name="iv_applicant_phone_no"
                    autoComplete='off'
                    value={values.iv_applicant_phone_no}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{ maxLength: 11 }}
                    id="iv_applicant_phone_no_pp"
                    className='textInputField1 customer-input-unified'
                />
                <Box className='from-Error'>
                    {(showSubmitErrors || touched.iv_applicant_phone_no) && errors.iv_applicant_phone_no
                        ? errors.iv_applicant_phone_no
                        : null}
                </Box>
            </Grid>
            <Grid item {...col.narrow}>
                <Typography className='fieldLabel'>Phase</Typography>
                <TextField
                    fullWidth
                    required
                    type='text'
                    name="iv_phase"
                    disabled
                    autoComplete='off'
                    value={values.iv_phase}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField1 customer-input-unified'
                />
                <Box className='from-Error'>
                    {errors.iv_phase && touched.iv_phase ? (errors.iv_phase) : null}
                </Box>
            </Grid>
            {!hideMeterType && (
            <Grid item {...col.phaseMeter}>
                <Typography className='fieldLabel'>Meter Type</Typography>
                <TextField
                    fullWidth
                    required
                    type='text'
                    name="iv_meter_type"
                    disabled
                    autoComplete='off'
                    value={values.iv_meter_type}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField1 customer-input-unified'
                />
                <Box className='from-Error'>
                    {errors.iv_meter_type && touched.iv_meter_type ? (errors.iv_meter_type) : null}
                </Box>
            </Grid>
            )}
            {!hideTariff && (
            <Grid item {...col.phaseMeter}>
                <Typography className='fieldLabel'>Tariff</Typography>
                <TextField
                    fullWidth
                    required
                    type='text'
                    name="iv_tariff_description"
                    disabled
                    autoComplete='off'
                    value={values.iv_tariff_description}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField1 customer-input-unified'
                />
                <Box className='from-Error'>
                    {errors.iv_tariff_description && touched.iv_tariff_description ? (errors.iv_tariff_description) : null}
                </Box>
            </Grid>
            )}
        </>
    );

    const applicantInstRow2Fields = (
        <>
            <Grid item {...col.phone}>
                <Typography className='fieldLabel'>
                    Phone No. <span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                    fullWidth
                    required
                    type='text'
                    name="iv_applicant_phone_no"
                    autoComplete='off'
                    value={values.iv_applicant_phone_no}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{ maxLength: 11 }}
                    id="iv_applicant_phone_no_inst"
                    className='textInputField1 customer-input-unified'
                />
                <Box className='from-Error'>
                    {(showSubmitErrors || isInstLayout) && errors.iv_applicant_phone_no
                        ? errors.iv_applicant_phone_no
                        : null}
                </Box>
            </Grid>
            <Grid item {...col.phaseMeter}>
                <Typography className='fieldLabel'>Meter Type</Typography>
                <TextField
                    fullWidth
                    required
                    type='text'
                    name="iv_meter_type"
                    disabled
                    autoComplete='off'
                    value={values.iv_meter_type}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField1 customer-input-unified'
                />
                <Box className='from-Error'>
                    {errors.iv_meter_type && touched.iv_meter_type ? (errors.iv_meter_type) : null}
                </Box>
            </Grid>
            {!hideCategory && (
            <Grid item {...col.narrow}>
                <Typography className='fieldLabel'>Category</Typography>
                <TextField
                    fullWidth
                    required
                    type='text'
                    name="iv_connection_type"
                    disabled
                    autoComplete='off'
                    value={values.iv_connection_type}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField1 customer-input-unified'
                />
                <Box className='from-Error'>
                    {errors.iv_connection_type && touched.iv_connection_type ? (errors.iv_connection_type) : null}
                </Box>
            </Grid>
            )}
            <Grid item {...col.narrow}>
                <Typography className='fieldLabel'>Phase</Typography>
                <TextField
                    fullWidth
                    required
                    type='text'
                    name="iv_phase"
                    disabled
                    autoComplete='off'
                    value={values.iv_phase}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField1 customer-input-unified'
                />
                <Box className='from-Error'>
                    {errors.iv_phase && touched.iv_phase ? (errors.iv_phase) : null}
                </Box>
            </Grid>
            {!hideTariff && (
            <Grid item {...col.tariff}>
                <Typography className='fieldLabel'>Tariff</Typography>
                <TextField
                    fullWidth
                    required
                    type='text'
                    name="iv_tariff_description"
                    disabled
                    autoComplete='off'
                    value={values.iv_tariff_description}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField1 customer-input-unified'
                />
                <Box className='from-Error'>
                    {errors.iv_tariff_description && touched.iv_tariff_description ? (errors.iv_tariff_description) : null}
                </Box>
            </Grid>
            )}
        </>
    );

    const applicantInstRow3Fields = (
        <>
            <Grid item {...col.location}>
                <Typography className='fieldLabel'>Circle</Typography>
                <TextField
                    fullWidth
                    disabled
                    id="iv_circle"
                    name="iv_circle"
                    value={defaultCircle?.name ?? ''}
                    className='textInputField1 customer-input-unified'
                />
                <Box className='from-Error'>
                    {errors.iv_circle && touched.iv_circle ? (errors.iv_circle) : null}
                </Box>
            </Grid>
            <Grid item {...col.location}>
                <Typography className='fieldLabel'>Division</Typography>
                <TextField
                    fullWidth
                    disabled
                    id="iv_division"
                    name="iv_division"
                    value={defaultDivision?.name ?? ''}
                    className='textInputField1 customer-input-unified'
                />
                <Box className='from-Error'>
                    {errors.iv_division && touched.iv_division ? (errors.iv_division) : null}
                </Box>
            </Grid>
            <Grid item {...col.location}>
                <Typography className='fieldLabel'>Sub Division</Typography>
                <TextField
                    fullWidth
                    disabled
                    id="iv_sub_divison"
                    name="iv_sub_divison"
                    value={subDivision?.name ?? ''}
                    className='textInputField1 customer-input-unified'
                />
                <Box className='from-Error'>
                    {errors.iv_sub_divison && touched.iv_sub_divison ? (errors.iv_sub_divison) : null}
                </Box>
            </Grid>
            <Grid item {...col.address}>
                <Typography className='fieldLabel'>Address</Typography>
                <TextField
                    fullWidth
                    name='iv_address'
                    required
                    type='text'
                    value={values.iv_address}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled
                    className='textInputField1 customer-input-unified'
                />
            </Grid>
        </>
    );

    const applicantPpRow3Fields = (
        <>
            <Grid item {...col.location}>
                <Typography className='fieldLabel'>Circle</Typography>
                <TextField
                    fullWidth
                    disabled
                    id="iv_circle"
                    name="iv_circle"
                    value={defaultCircle?.name ?? ''}
                    className='textInputField1 customer-input-unified'
                />
                <Box className='from-Error'>
                    {errors.iv_circle && touched.iv_circle ? (errors.iv_circle) : null}
                </Box>
            </Grid>
            <Grid item {...col.location}>
                <Typography className='fieldLabel'>Division</Typography>
                <TextField
                    fullWidth
                    disabled
                    id="iv_division"
                    name="iv_division"
                    value={defaultDivision?.name ?? ''}
                    className='textInputField1 customer-input-unified'
                />
                <Box className='from-Error'>
                    {errors.iv_division && touched.iv_division ? (errors.iv_division) : null}
                </Box>
            </Grid>
            <Grid item {...col.location}>
                <Typography className='fieldLabel'>Sub Division</Typography>
                <TextField
                    fullWidth
                    disabled
                    id="iv_sub_divison"
                    name="iv_sub_divison"
                    value={subDivision?.name ?? ''}
                    className='textInputField1 customer-input-unified'
                />
                <Box className='from-Error'>
                    {errors.iv_sub_divison && touched.iv_sub_divison ? (errors.iv_sub_divison) : null}
                </Box>
            </Grid>
            <Grid item {...col.address}>
                <Typography className='fieldLabel'>Address</Typography>
                <TextField
                    fullWidth
                    name='iv_address'
                    required
                    type='text'
                    value={values.iv_address}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled
                    className='textInputField1 customer-input-unified'
                />
            </Grid>
        </>
    );

    const applicantRow2Fields = (
        <>
            {isAlbLayout && showTelco && (
            <Grid item {...col.telco}>
                <Typography className='fieldLabel'>
                  Telco <span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                    fullWidth
                    select
                    required
                    name="iv_telco"
                    value={
                      values.iv_telco === 0 || values.iv_telco == null
                        ? ''
                        : String(values.iv_telco)
                    }
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(errors.iv_telco && touched.iv_telco)}
                    className='textInputField customer-input-unified'
                    SelectProps={{
                      displayEmpty: true,
                      MenuProps: DARK_SAFE_SELECT_MENU_PROPS,
                    }}
                >
                    <MenuItem value="">
                      <em>Select Telco</em>
                    </MenuItem>
                    <MenuItem value="1">Jazz</MenuItem>
                    <MenuItem value="2">Ufone</MenuItem>
                    <MenuItem value="3">Telenor</MenuItem>
                    <MenuItem value="4">Zong</MenuItem>
                </TextField>
                <Box className='from-Error'>
                    {errors.iv_telco && touched.iv_telco ? errors.iv_telco : null}
                </Box>
            </Grid>
            )}

            {isAlbLayout && (
            <Grid item {...col.phone}>
                <Typography className='fieldLabel'>
                  Phone No. <span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                    fullWidth
                    required
                    type='text'
                    name="iv_applicant_phone_no"
                    autoComplete='off'
                    value={values.iv_applicant_phone_no}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(
                      errors.iv_applicant_phone_no && touched.iv_applicant_phone_no
                    )}
                    inputProps={{ maxLength: 11, style: { backgroundColor: "#ffffff" } }}
                    InputProps={{ style: { backgroundColor: "#ffffff" } }}
                    id="iv_applicant_phone_no"
                    className='textInputField customer-input-unified'
                    placeholder="03XXXXXXXXX"
                    style={{ backgroundColor: "#ffffff" }}
                />
                <Box className='from-Error'>
                    {errors.iv_applicant_phone_no && touched.iv_applicant_phone_no
                        ? errors.iv_applicant_phone_no
                        : null}
                </Box>
            </Grid>
            )}

            {isAlbLayout && !hideCategory && (
            <Grid item {...col.narrow}>
                <Typography className='fieldLabel'>Category</Typography>
                <TextField
                    fullWidth
                    required
                    type='text'
                    name="iv_connection_type"
                    disabled
                    autoComplete='off'
                    value={values.iv_connection_type}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField1'
                />
                <Box className='from-Error'>
                    {errors.iv_connection_type && touched.iv_connection_type ? (errors.iv_connection_type) : null}
                </Box>
            </Grid>
            )}

            {isAlbLayout && !hidePhase && (
            <Grid item {...col.narrow}>
                <Typography className='fieldLabel'>Phase</Typography>
                <TextField
                    fullWidth
                    required
                    type='text'
                    name="iv_phase"
                    disabled
                    autoComplete='off'
                    value={values.iv_phase}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField1 customer-input-unified'
                />
                <Box className='from-Error'>
                    {errors.iv_phase && touched.iv_phase ? (errors.iv_phase) : null}
                </Box>
            </Grid>
            )}

            {/* Meter Type */}
            {!hideMeterType && (
            <Grid item {...(isWideLayout ? col.phaseMeter : col.narrow)}>
                <Typography className='fieldLabel'>Meter Type</Typography>
                <TextField
                    fullWidth
                    required
                    type='text'
                    name="iv_meter_type"
                    disabled
                    autoComplete='off'
                    value={values.iv_meter_type}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField1 customer-input-unified'
                    sx={
                        isWideLayout || isAlbLayout
                            ? undefined
                            : { backgroundColor: values.iv_meter_type !== 'Smart' ? 'blue' : '' }
                    }
                />
                <Box className='from-Error'>
                    {errors.iv_meter_type && touched.iv_meter_type ? (errors.iv_meter_type) : null}
                </Box>
            </Grid>
            )}

            {/* Tariff */}
            {!hideTariff && (
            <Grid item {...(col.tariff || col.narrow)}>
                <Typography className='fieldLabel'>Tariff</Typography>
                <TextField
                    fullWidth
                    required
                    type='text'
                    name="iv_tariff_description"
                    disabled
                    autoComplete='off'
                    value={values.iv_tariff_description}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField1'
                />
                <Box className='from-Error'>
                    {errors.iv_tariff_description && touched.iv_tariff_description ? (errors.iv_tariff_description) : null}
                </Box>
            </Grid>
            )}

            {/* Company — admin / company-level users only */}
            {showCompany && (
            <Grid item {...(isWideLayout ? col.locationSm : col.location)}>
                <Typography className='fieldLabel'>Company</Typography>
                <TextField
                    fullWidth
                    disabled
                    id="iv_company"
                    name="iv_company"
                    value={companyDisplayName ?? ''}
                    className={`textInputField1${isWideLayout ? ' customer-input-unified' : ''}`}
                />
            </Grid>
            )}

            {/* Circle */}
            <Grid item {...(isWideLayout ? col.locationSm : col.location)}>
                <Typography className='fieldLabel'>Circle</Typography>
                <TextField
                    fullWidth
                    disabled
                    id="iv_circle"
                    name="iv_circle"
                    value={defaultCircle?.name ?? ''}
                    className={`textInputField1${isWideLayout ? ' customer-input-unified' : ''}`}
                />
                <Box className='from-Error'>
                    {errors.iv_circle && touched.iv_circle ? (errors.iv_circle) : null}
                </Box>
            </Grid>

            {/* Division */}
            <Grid item {...(isRcoLayout ? col.division : isWideLayout ? col.locationSm : col.location)}>
                <Typography className='fieldLabel'>Division</Typography>
                <TextField
                    fullWidth
                    disabled
                    id="iv_division"
                    name="iv_division"
                    value={defaultDivision?.name ?? ''}
                    className={`textInputField1${isWideLayout ? ' customer-input-unified' : ''}`}
                />
                <Box className='from-Error'>
                    {errors.iv_division && touched.iv_division ? (errors.iv_division) : null}
                </Box>
            </Grid>

            {/* Sub Division */}
            <Grid item {...(isRcoLayout ? col.subDivision : isWideLayout ? col.locationSm : col.location)}>
                <Typography className='fieldLabel'>Sub Division</Typography>
                <TextField
                    fullWidth
                    disabled
                    id="iv_sub_divison"
                    name="iv_sub_divison"
                    value={subDivision?.name ?? ''}
                    className={`textInputField1${isWideLayout ? ' customer-input-unified' : ''}`}
                />
                <Box className='from-Error'>
                    {errors.iv_sub_divison && touched.iv_sub_divison ? (errors.iv_sub_divison) : null}
                </Box>
            </Grid>

            {/* Address */}
            <Grid item {...col.address}>
                <Typography className='fieldLabel'>Address</Typography>
                <TextField
                    fullWidth
                    name='iv_address'
                    required
                    type='text'
                    value={values.iv_address}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled
                    className={
                        isAlbLayout || isPpLayout || isInstLayout || isRcoLayout
                            ? 'textInputField1 customer-input-unified'
                            : `textInputFieldAddressing${isWideLayout ? ' customer-input-unified' : ''}`
                    }
                />
            </Grid>

            {showStatusAfterAddress && (
            <Grid item {...col.status} className={isRcoLayout ? 'rco-status-grid-item' : undefined}>
                <Typography className='fieldLabel'>Status</Typography>
                <FormControl
                    margin="none"
                    className={`form-control${isRcoLayout ? ' form-control--rco-status' : ''}`}
                >
                    <RadioGroup
                        className="radio-group"
                        row
                        name="iv_applicant_status"
                        value={values.iv_applicant_status ?? 'Owner'}
                        onChange={handleChange}
                    >
                        <FormControlLabel
                            value="Owner"
                            className="form-control-label"
                            control={<Radio size={isRcoLayout ? 'small' : 'medium'} />}
                            label="Owner"
                            labelPlacement="end"
                        />
                        <FormControlLabel
                            value="Tenant"
                            className="form-control-label"
                            control={<Radio size={isRcoLayout ? 'small' : 'medium'} />}
                            label="Tenant"
                            labelPlacement="end"
                        />
                    </RadioGroup>
                </FormControl>
                <Box className='from-Error'>
                    {errors.iv_applicant_status && touched.iv_applicant_status
                        ? errors.iv_applicant_status
                        : null}
                </Box>
            </Grid>
            )}
        </>
    );

    return (
        <>
        <Grid
            container
            className={`container${isWideLayout ? ' container--wide' : ''}${isRcoLayout ? ' container--rco container--rco-row1' : ''}${isAlbLayout ? ' container--alb' : ''}${isPpLayout ? ' container--alb container--pp' : ''}${isInstLayout ? ' container--alb container--inst' : ''}`}
            spacing={isRcoLayout ? 0.5 : isSplitRow2Layout ? 1 : 2}
            wrap={isRcoLayout ? 'nowrap' : 'wrap'}
        >

            {/* Search By Section */}
            {!isSingleSearchOption && (
                <Grid item {...col.search} className="customer-search-grid-item">
                    <Typography className="fieldLabel">Search By</Typography>
                    <div className={isSplitRow2Layout ? 'customer-search-control' : undefined}>
                        <FormControl margin="none" className="form-control form-control--search-by">
                            <RadioGroup
                                className="radio-group"
                                row
                                name="iv_search_by"
                                value={searchBy}
                                onChange={SearchBy}
                            >
                                {allowedSearchBy.includes('referenceNo') && (
                                    <FormControlLabel
                                        value="referenceNo"
                                        control={<Radio size="small" />}
                                        label="Reference No."
                                    />
                                )}

                                {allowedSearchBy.includes('consumerId') && (
                                    <FormControlLabel
                                        value="consumerId"
                                        control={<Radio size="small" />}
                                        label="Customer ID."
                                    />
                                )}
                            </RadioGroup>
                        </FormControl>
                    </div>
                    {(isSplitRow2Layout && !isInstLayout) && (
                        <Box className="from-Error from-Error--spacer" aria-hidden="true" />
                    )}
                </Grid>
            )}

            {/* Customer ID Field */}
            {searchBy === 'consumerId' && (
                <Grid item {...col.ref}>
                    <Typography className='fieldLabel'>Customer ID.</Typography>
                    <TextField
                        fullWidth
                        type='text'
                        name="iv_consumer_id"
                        autoComplete='off'
                        value={values.iv_consumer_id}
                        onChange={handleConsumerIdChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.iv_consumer_id && touched.iv_consumer_id)}
                        inputProps={{ maxLength: 10, inputMode: 'numeric', pattern: '\\d*' }}
                        id="iv_consumer_id"
                        className={`textInputField${isWideLayout ? ' customer-input-unified' : ''}`}
                    />
                    <Box className='from-Error'>
                        {errors.iv_consumer_id && touched.iv_consumer_id ? (errors.iv_consumer_id) : null}
                    </Box>
                </Grid>
            )}

            {/* Reference No Field */}
            {searchBy === 'referenceNo' && (
                <Grid item {...col.ref}>
                    <Typography className='fieldLabel'>Reference No.</Typography>
                    <TextField
                        fullWidth
                        type='text'
                        name="iv_reference_number"
                        autoComplete='off'
                        value={values.iv_reference_number}
                        onChange={handleReferenceNumberChange}
                        onBlur={handleBlur}
                        error={Boolean(
                          errors.iv_reference_number && touched.iv_reference_number
                        )}
                        inputProps={{ maxLength: 14, inputMode: 'numeric', pattern: '\\d*' }}
                        id="iv_reference_number"
                        className={`textInputField${isWideLayout ? ' customer-input-unified' : ''}`}
                    />
                    <Box className='from-Error'>
                        {errors.iv_reference_number && touched.iv_reference_number ? (errors.iv_reference_number) : null}
                    </Box>
                </Grid>
            )}

            {/* Name */}
            <Grid item {...col.name}>
                <Typography className='fieldLabel'>Name</Typography>
                <TextField
                    fullWidth
                    required
                    type='text'
                    name="iv_applicant_name"
                    value={values.iv_applicant_name}
                    autoComplete='off'
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled
                    id="iv_applicant_name"
                    className={`textInputField1${isWideLayout ? ' customer-input-unified' : ''}`}
                />
                <Box className='from-Error'>
                    {errors.iv_applicant_name && touched.iv_applicant_name ? (errors.iv_applicant_name) : null}
                </Box>
            </Grid>

            {/* Father's / Husband's Name */}
            <Grid item {...col.father}>
                <Typography className='fieldLabel'>Father's / Husband's Name</Typography>
                <TextField
                    fullWidth
                    required
                    type='text'
                    name="iv_father_name"
                    value={values.iv_father_name}
                    autoComplete='off'
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled
                    id="iv_father_name"
                    className={`textInputField1${isWideLayout ? ' customer-input-unified' : ''}`}
                />
                <Box className='from-Error'>
                    {errors.iv_father_name && touched.iv_father_name ? (errors.iv_father_name) : null}
                </Box>
            </Grid>

            {/* NIC / CNIC / NICOP */}
            <Grid item {...col.cnic}>
                <Typography className='fieldLabel'>NIC. / CNIC. / NICOP.</Typography>
                <TextField
                    fullWidth
                    required
                    type='text'
                    name="iv_applicant_cnic"
                    disabled
                    value={values.iv_applicant_cnic}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="iv_applicant_cnic"
                    className={`textInputField1${isWideLayout ? ' customer-input-unified' : ''}`}
                />
                <Box className='from-Error'>
                    {errors.iv_applicant_cnic && touched.iv_applicant_cnic ? (errors.iv_applicant_cnic) : null}
                </Box>
            </Grid>

            {/* Telco — non-ALB layouts keep Telco beside CNIC; ALB shows it with Phone */}
            {showTelco && !isAlbLayout && !isPpLayout && !isInstLayout && (
            <Grid item {...col.telco}>
                <Typography className='fieldLabel'>
                  Telco <span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                    fullWidth
                    select
                    required
                    name="iv_telco"
                    value={values.iv_telco ?? ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField customer-input-unified'
                    SelectProps={{
                      MenuProps: DARK_SAFE_SELECT_MENU_PROPS,
                    }}
                >
                    <MenuItem value={0}>Select</MenuItem>
                    <MenuItem value={1}>Jazz</MenuItem>
                    <MenuItem value={1}>Warid</MenuItem>
                    <MenuItem value={2}>Ufone</MenuItem>
                    <MenuItem value={2}>Onic</MenuItem>
                    <MenuItem value={3}>Telenor</MenuItem>
                    <MenuItem value={4}>Zong</MenuItem>
                    <MenuItem value={5}>SCom</MenuItem>
                </TextField>
                <Box className='from-Error'>
                    {errors.iv_telco ? errors.iv_telco : null}
                </Box>
            </Grid>
            )}

            {/* Phone No */}
            {!isAlbLayout && !isPpLayout && !isInstLayout && (
           <Grid item {...col.phone}>
    <Typography className='fieldLabel'>
      Phone No.{(showTelco || isRcoLayout) && <span style={{ color: 'red' }}> *</span>}
    </Typography>
    <TextField
      fullWidth
      required
      type='text'
      name="iv_applicant_phone_no"
      autoComplete='off'
      value={values.iv_applicant_phone_no}
      onChange={handleChange}
      onBlur={handleBlur}
      inputProps={{ maxLength: 11 }}
      id="iv_applicant_phone_no"
      className='textInputField customer-input-unified'
    />
    <Box className='from-Error'>
      {errors.iv_applicant_phone_no ? errors.iv_applicant_phone_no : null}
    </Box>
  </Grid>
            )}

            {/* Category */}
            {!hideCategory && !isSplitRow2Layout && (
            <Grid item {...col.narrow}>
                <Typography className='fieldLabel'>Category</Typography>
                <TextField
                    fullWidth
                    required
                    type='text'
                    name="iv_connection_type"
                    disabled
                    autoComplete='off'
                    value={values.iv_connection_type}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField1'
                />
                <Box className='from-Error'>
                    {errors.iv_connection_type && touched.iv_connection_type ? (errors.iv_connection_type) : null}
                </Box>
            </Grid>
            )}

            {/* Phase */}
            {!isAlbLayout && !isPpLayout && !isInstLayout && (
            <Grid item {...(isRcoLayout ? col.phase : isWideLayout ? col.phaseMeter : col.narrow)}>
                <Typography className='fieldLabel'>Phase</Typography>
                <TextField
                    fullWidth
                    required
                    type='text'
                    name="iv_phase"
                    disabled
                    autoComplete='off'
                    value={values.iv_phase}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField1 customer-input-unified'
                />
                <Box className='from-Error'>
                    {errors.iv_phase && touched.iv_phase ? (errors.iv_phase) : null}
                </Box>
            </Grid>
            )}

            {isPpLayout && applicantPpRow2Fields}
            {isPpLayout && applicantPpRow3Fields}
            {isInstLayout && applicantInstRow2Fields}
            {isInstLayout && applicantInstRow3Fields}

            {!isSplitRow2Layout && applicantRow2Fields}

        </Grid>

        {isSplitRow2Layout && !isPpLayout && !isInstLayout && (
            <Grid
                container
                spacing={isRcoLayout ? 0.5 : 1}
                wrap={isRcoLayout ? 'nowrap' : 'wrap'}
                className={`container${isRcoLayout ? ' container--rco container--rco-row2' : ' container--alb container--alb-row2'}`}
            >
                {applicantRow2Fields}
            </Grid>
        )}
        </>
    );
};

export default CustomerInformationCard;
